<div id="apx" class="customer-portal-wrappper-cp" [ngClass]="appliedClass">
    @if (appFacadeService.getAuthenticated() | async) { @if (isSyrnix()) {
    <ng-container *ngTemplateOutlet="syrinxAdminTabs"></ng-container>
    } @else { @if (configService.adminInputs$ | async; as adminInputs) {
    <ng-container class="holder">
        @if (versionLoaded$ | async) {
        <ng-container *ngTemplateOutlet="headerTemplate; context: { showTabs: (appFacadeService.shouldShowMenu() | async), adminInputs }"></ng-container>
        <ng-container class="customer-portal-admin">
            @switch (appFacadeService.getActiveTab() | async) { @default {
            <por-admin-overview [adminConfig]="adminInputs"></por-admin-overview>
            } @case ('AdminWebpay') {
            <por-admin-webpay [config]="(orgConfig$ | async) || {}"></por-admin-webpay>
            } @case ('AdminSetup') {
            <por-admin-mandatory
                [showWysiwyg]="false"
                [config]="(orgConfig$ | async) || {}"
                [adminConfig]="adminInputs"
                (formSubmitted)="doScrollToTop = true"
                (classEmitter)="onClassReceived($event)"></por-admin-mandatory>
            } @case ('AdminAccountList') {
            <por-admin-account-list></por-admin-account-list>
            } @case ('AdminAnalytics') {
            <por-analytics></por-analytics>
            } }
        </ng-container>
        }
    </ng-container>
    } } } @if ((appFacadeService.getAuthenticated() | async) === false || (appFacadeService.getAdminLoaded() | async)) {
    <div class="consumer-portal-loading" [ngClass]="appliedClass">
        <div class="onboarding-error-container">
            @if (!isOnboardingEligible()) {
            <strong>{{ (errorMessage$ | async)?.message || ('Please wait' | translate) }}</strong>
            } @if (isOnboardingEligible()) {
            <por-cp-onboard-panel [orgId]="parsedOrgId" [email]="parsedEmail" [isProduction]="isProduction()" [configCredentials]="onboardConfigCredentials()"></por-cp-onboard-panel>
            }
        </div>
    </div>
    }
    <ng-template #syrinxAdminTabs>
        @if (configService.adminInputs$ | async; as adminInputs) {
        <ng-container class="holder">
            <ng-container *ngTemplateOutlet="headerTemplate; context: { showTabs: (appFacadeService.shouldShowMenu() | async), adminInputs }"></ng-container>
            <ng-container class="customer-portal-admin">
                @switch (appFacadeService.getActiveTab() | async) { @default {
                <por-admin-mandatory [showWysiwyg]="false" [config]="(orgConfig$ | async) || {}" [adminConfig]="adminInputs" (formSubmitted)="doScrollToTop = true"></por-admin-mandatory>
                } @case ('AdminAccountList') {
                <por-admin-account-list></por-admin-account-list>
                } }
            </ng-container>
        </ng-container>
        }
    </ng-template>
    <ng-template #headerTemplate let-showTabs="showTabs" let-adminInputs="adminInputs">
        <por-admin-header [porScrollTo]="doScrollToTop" (scrollComplete)="resetScrollFlag()" [config]="(orgConfig$ | async) || {}" [adminConfig]="adminInputs" [showTabs]="showTabs"></por-admin-header>
    </ng-template>
</div>
